export default "__VITE_ASSET__BIdM8IoE__"